import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Select from '../../components/Select/Select';
import Button from '../../components/Button/Button';
import getMarks from '../../api/cars/getMarks';
import getCities from '../../api/resources/getCities';
import commitStockCorrections from '../../api/cars/commitStockCorrections';
import alert from '../../helpers/alert';
import useOriginOptions, { decomposeOrigin, originOptionFor } from './useOriginOptions';
import PendingRowForm from './PendingRowForm';
import ComplectationQuestions from './ComplectationQuestions';
import styles from './stockPendingRowsTable.module.css';

// ÐÐ´ÐµÐ½ÑÐ¸ÑÐ½Ð¾ÑÑÑ ÑÑÑÐ¾ÐºÐ¸ = ÑÐ°Ð¹Ð» + Ð½Ð¾Ð¼ÐµÑ ÑÑÑÐ¾ÐºÐ¸: Ð² Ð¼ÑÐ»ÑÑÐ¸ÑÐ°Ð¹Ð»Ð¾Ð²Ð¾Ð¹ Ð¿Ð°ÑÐºÐµ Ð¾Ð´Ð¸Ð½ Ð¸ ÑÐ¾Ñ
// Ð¶Ðµ Ð½Ð¾Ð¼ÐµÑ ÑÑÑÐ¾ÐºÐ¸ Ð²ÑÑÑÐµÑÐ°ÐµÑÑÑ Ð² ÐºÐ°Ð¶Ð´Ð¾Ð¼ ÑÐ°Ð¹Ð»Ðµ, Ð³Ð¾Ð»ÑÐ¹ row Ð½Ðµ ÑÐ½Ð¸ÐºÐ°Ð»ÐµÐ½. Ð­ÑÐ¾Ñ ÐºÐ»ÑÑ
// Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð´Ð»Ñ Ð²ÑÐµÐ³Ð¾ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð³Ð¾ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ ÑÐ°Ð±Ð»Ð¸ÑÑ (Ð²ÑÐ±Ð¾Ñ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ,
// ÑÐ°ÑÐºÑÑÑÐ¸Ðµ ÑÑÑÐ¾Ðº, Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²ÐºÐ° ÐºÐ½Ð¾Ð¿Ð¾Ðº) Ð¸ ÐºÐ°Ðº React key
const rowKey = (row) => `${row.fileName || ''}|${row.row}`;

// Ð¡ÑÑÐ¾ÐºÐ° Ð¿Ð¾Ð»Ð½Ð¾ÑÑÑÑ ÑÐµÐ·Ð¾Ð»Ð²Ð»ÐµÐ½Ð° Ð±ÑÐºÐ¾Ð¼ (Ð¼Ð°ÑÐºÐ°/Ð¼Ð¾Ð´ÐµÐ»Ñ/Ð³Ð¾ÑÐ¾Ð´/ÐÐ¦ Ð½Ð°Ð´ÑÐ¶Ð½Ð¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ñ),
// Ð½Ðµ ÑÐ²Ð°ÑÐ°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ â Ð¾Ð½Ð¾ Ð½Ðµ Ð²ÑÐµÐ³Ð´Ð° ÐµÑÑÑ Ð² Ð¸ÑÑÐ¾Ð´Ð½Ð¾Ð¼ ÑÐ°Ð¹Ð»Ðµ (CRM-
// Ð²ÑÐ³ÑÑÐ·ÐºÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð²Ð¾Ð¾Ð±ÑÐµ Ð½Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ ÑÑÐ¾ Ð¿Ð¾Ð»Ðµ). Ð¢Ð°ÐºÐ¸Ðµ ÑÑÑÐ¾ÐºÐ¸ Ð½Ðµ Ð´Ð¾Ð»Ð¶Ð½Ñ
// Ð·Ð°ÑÑÐ°Ð²Ð»ÑÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð·Ð°Ð½Ð¾Ð²Ð¾ ÑÐ°Ð·Ð±Ð¸ÑÐ°ÑÑ Ð¿Ð¾Ð»Ð½Ð¾ÑÐµÐ½Ð½ÑÑ ÑÐ¾ÑÐ¼Ñ â ÑÐ¾Ð»ÑÐºÐ¾ Ð²ÑÐ±ÑÐ°ÑÑ
// Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ
const buildOriginOnlyResolution = (row, originOption) => ({
  fileName: row.fileName || null,
  row: row.row,
  markId: row.resolvedMarkId,
  modelId: row.resolvedModelId,
  complectationTitle: row.complectationName || '',
  cityId: row.resolvedCityId,
  dcId: row.resolvedDcId,
  vin: row.vin,
  color: row.color || '',
  engineVolume: row.engineVolume || '',
  engineType: row.engineType || null,
  transmission: row.transmission || null,
  priceStr: row.priceStr,
  issueYear: row.yearStr,
  // ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ¶Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸Ð» ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ Ð½Ð¾Ð²Ð¾Ð¹ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸, ÑÑÑÐ¾ÐºÐ° Ð¶Ð´Ð°Ð»Ð° ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ
  createComplectation: !!row.createComplectation,
  ...decomposeOrigin(originOption),
});

// ÐÐ´Ð½Ð° ÑÑÑÐ¾ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ "ÐÑÐ¸Ð±ÐºÐ¸" â Ð²ÑÐ½ÐµÑÐµÐ½Ð° Ð² Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹ React.memo-ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½Ñ.
// ÐÐ° ÑÐ°Ð¹Ð»Ðµ Ð² ÑÑÑÑÑÑ Ð¾ÑÐ¸Ð±Ð¾ÑÐ½ÑÑ ÑÑÑÐ¾Ðº ÑÐ°Ð½ÑÑÐµ Ð²ÑÑ ÑÑÐ° ÑÐ°Ð·Ð¼ÐµÑÐºÐ° ÑÐµÐ½Ð´ÐµÑÐ¸Ð»Ð°ÑÑ Ð¸Ð½Ð»Ð°Ð¹Ð½
// Ð²Ð½ÑÑÑÐ¸ .map() Ñ ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ: Ð»ÑÐ±Ð¾Ðµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ (ÐºÐ»Ð¸Ðº Ð¿Ð¾ ÑÑÑÐ¾ÐºÐµ, Ð²ÑÐ±Ð¾Ñ
// Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð² ÐÐÐÐÐ ÑÑÑÐ¾ÐºÐµ) Ð²ÑÐ·ÑÐ²Ð°Ð»Ð¾ ÑÐµ-ÑÐµÐ½Ð´ÐµÑ Ð²ÑÐµÑ 1000+ ÑÑÑÐ¾Ðº ÑÐ°Ð·Ð¾Ð¼,
// Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ ÐºÐ¾Ð»Ð±ÑÐºÐ¸/Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¿ÐµÑÐµÑÐ¾Ð·Ð´Ð°Ð²Ð°Ð»Ð¸ÑÑ Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐµÐ½Ð´ÐµÑ Ð¸ React Ð½Ðµ Ð¼Ð¾Ð³
// bail-out Ð¿Ð¾ shallow-equal Ð¿ÑÐ¾Ð¿ÑÐ¾Ð². ÐÐ»ÑÑ ÑÐ°Ð¼Ð° PendingRowForm (react-hook-form
// + Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ react-select) Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð»Ð°ÑÑ Ð´Ð»Ñ ÐÐ¡ÐÐ¥ ÑÑÑÐ¾Ðº ÑÑÐ°Ð·Ñ, Ð¿ÑÐ¾ÑÑÐ¾ ÑÐºÑÑÑÐ°Ñ
// ÑÐµÑÐµÐ· display:none â Ð¾ÑÑÑÐ´Ð° Ð¸ Ð¼ÐµÐ´Ð»ÐµÐ½Ð½ÑÐ¹ Ð¿ÐµÑÐ²ÑÐ¹ ÑÐµÐ½Ð´ÐµÑ.
// Ð¢ÑÑ ÑÐ¾ÑÐ¼Ñ Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐ²Ð¾Ð³Ð¾ ÑÐ°Ð·Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ñ ÑÑÑÐ¾ÐºÐ¸ (Ð¸ Ð½Ðµ
// ÑÐ°Ð·Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÐ¼ Ð¾Ð±ÑÐ°ÑÐ½Ð¾ â ÑÑÐ¾Ð±Ñ Ð½Ðµ ÑÐµÑÑÑÑ ÑÐ¾, ÑÑÐ¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÑÐ¿ÐµÐ» Ð²Ð²ÐµÑÑÐ¸).
const PendingErrorRow = React.memo(function PendingErrorRow({
  row,
  isExpanded,
  showFileNames,
  originOptions,
  originOption,
  allCities,
  allMarks,
  onToggle,
  onOriginChange,
  onSubmitRow,
  dcCache,
  createdModels,
  onModelCreated,
}) {
  const key = rowKey(row);
  const [hasOpened, setHasOpened] = useState(isExpanded);
  useEffect(() => {
    if (isExpanded) setHasOpened(true);
  }, [isExpanded]);

  return (
    <div className={styles.rowWrapper}>
      <button type="button" className={styles.rowSummary} onClick={() => onToggle(key)}>
        <span className={styles.rowChevron}>{isExpanded ? 'â¾' : 'â¸'}</span>
        <span className={styles.rowNumber}>Ð¡ÑÑÐ¾ÐºÐ° {row.row}</span>
        {showFileNames && row.fileName && <span className={styles.rowFile}>{row.fileName}</span>}
        <span className={styles.rowVin}>{row.vin}</span>
        <span className={styles.rowSummaryError}>
          {row.errors?.[0]}
          {row.errors?.length > 1 && ` (+${row.errors.length - 1})`}
        </span>
      </button>
      {hasOpened && (
        <div style={{ display: isExpanded ? undefined : 'none' }}>
          <div className={styles.rowOriginBar}>
            <Select
              title="ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ"
              placeholder="ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ð¾"
              options={originOptions}
              value={originOption}
              onChange={(val) => onOriginChange(key, val)}
            />
          </div>
          <PendingRowForm
            row={row}
            allCities={allCities}
            allMarks={allMarks}
            origin={originOption}
            onSubmitRow={onSubmitRow}
            dcCache={dcCache}
            createdModels={createdModels}
            onModelCreated={onModelCreated}
          />
        </div>
      )}
    </div>
  );
});

const StockPendingRowsTable = ({ sessionId, pendingRows, onResolved }) => {
  const [rows, setRows] = useState(pendingRows);
  const originOptions = useOriginOptions();
  const [cities, setCities] = useState([]);
  const [marks, setMarks] = useState([]);
  const [referenceLoaded, setReferenceLoaded] = useState(false);
  const [originByRow, setOriginByRow] = useState({});
  const [bulkOrigin, setBulkOrigin] = useState(null);
  // ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÑÑÐ¾ÐºÐ¸: Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ¾Ð¼, Ð° ÐµÑÐ»Ð¸ Ð½Ðµ Ð²ÑÐ±Ð¸ÑÐ°Ð» â ÑÐ°ÑÐ¿Ð¾Ð·Ð½Ð°Ð½Ð½Ð¾Ðµ Ð±ÑÐºÐ¾Ð¼ Ð² ÑÐ°Ð¹Ð»Ðµ
  const originOf = (row) =>
    originByRow[rowKey(row)] || originOptionFor(originOptions, row.resolvedOriginCarId, row.resolvedFactoryId);
  const [importingOriginOnly, setImportingOriginOnly] = useState(false);
  // ÐÐ¾Ð¼ÐµÑÐ° ÑÑÑÐ¾Ðº, Ð´Ð»Ñ ÐºÐ¾ÑÐ¾ÑÑÑ Ð¿ÑÑÐ¼Ð¾ ÑÐµÐ¹ÑÐ°Ñ Ð»ÐµÑÐ¸Ñ Ð¾Ð´Ð¸Ð½Ð¾ÑÐ½ÑÐ¹ commit â Ð±Ð»Ð¾ÐºÐ¸ÑÑÐµÐ¼
  // Ð¸Ð¼ÐµÐ½Ð½Ð¾ ÑÑÑ ÐºÐ½Ð¾Ð¿ÐºÑ/ÑÑÑÐ¾ÐºÑ Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼, ÑÑÐ¾ Ð·Ð°Ð¿ÑÐ¾Ñ Ð² Ð¿ÑÐ¾ÑÐµÑÑÐµ (Ð¸Ð½Ð°ÑÐµ Ð½Ðµ Ð²Ð¸Ð´Ð½Ð¾
  // Ð½Ð¸ÑÐµÐ³Ð¾ Ð´Ð¾ Ð¾ÑÐ²ÐµÑÐ° ÑÐµÑÐ²ÐµÑÐ°, Ð¸ Ð¼Ð¾Ð¶Ð½Ð¾ ÑÐ»ÑÑÐ°Ð¹Ð½Ð¾ Ð½Ð°Ð¶Ð°ÑÑ "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ" Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾)
  const [submittingOriginRows, setSubmittingOriginRows] = useState(() => new Set());
  const [activeTab, setActiveTab] = useState(null);
  const [expandedRows, setExpandedRows] = useState(() => new Set());
  // ÐÐ¾Ð´ÐµÐ»Ð¸, Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð½ÑÐµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¼ Ð¿ÑÑÐ¼Ð¾ Ð¸Ð· ÑÐ¾ÑÐ¼Ñ (ÑÐ¼. AddModelModal), Ð½Ð° Ð²ÑÑ
  // ÑÐ°Ð±Ð»Ð¸ÑÑ â ÐµÑÐ»Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ "Soul" Ð´Ð»Ñ KIA ÑÐ¾Ð·Ð´Ð°Ð»Ð¸ Ð² ÑÑÑÐ¾ÐºÐµ 247, ÑÑÑÐ¾ÐºÐ° 248 Ñ ÑÐ¾Ð¹ Ð¶Ðµ
  // Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹ Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¿Ð¾Ð´ÑÐ²Ð°ÑÐ¸ÑÑ ÐµÑ ÑÐ°Ð¼Ð°, Ð° Ð½Ðµ Ð·Ð°ÑÑÐ°Ð²Ð»ÑÑÑ Ð¸ÑÐºÐ°ÑÑ/Ð´Ð¾Ð±Ð°Ð²Ð»ÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.
  // ÐÐ»ÑÑ: `${markId}|${Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð² Ð½Ð¸Ð¶Ð½ÐµÐ¼ ÑÐµÐ³Ð¸ÑÑÑÐµ}`
  const [createdModels, setCreatedModels] = useState({});
  // ÐÐ±ÑÐ¸Ð¹ Ð½Ð° Ð²ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ ÐºÑÑ getDcList({cityId, mark}) â Ð³Ð¾ÑÐ¾Ð´+Ð¼Ð°ÑÐºÐ° ÑÐ°ÑÑÐ¾ Ð¿Ð¾Ð²ÑÐ¾ÑÑÑÑÑÑ
  // Ð² ÑÐ°Ð·Ð½ÑÑ ÑÑÑÐ¾ÐºÐ°Ñ Ð¾Ð´Ð½Ð¾Ð³Ð¾ ÑÐ°Ð¹Ð»Ð°, Ð½Ðµ ÑÑÐ½ÐµÐ¼ Ð¾Ð´Ð¸Ð½ Ð¸ ÑÐ¾Ñ Ð¶Ðµ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ Ð½Ð¾Ð²Ð¾Ð¹
  const dcCacheRef = useRef(new Map());

  // ÐÐ´Ð¸Ð½ Ð·Ð°Ð¿ÑÐ¾Ñ Ð³Ð¾ÑÐ¾Ð´Ð¾Ð² + Ð¾Ð´Ð¸Ð½ Ð·Ð°Ð¿ÑÐ¾Ñ Ð¿ÐµÑÐ²Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¼Ð°ÑÐ¾Ðº Ð½Ð° ÐÐ¡Ð® ÑÐ°Ð±Ð»Ð¸ÑÑ (Ð½Ðµ Ð½Ð°
  // ÑÑÑÐ¾ÐºÑ) â ÑÑÐ¾Ð³Ð¾ Ð´Ð¾ÑÑÐ°ÑÐ¾ÑÐ½Ð¾, ÑÑÐ¾Ð±Ñ ÑÐ¼Ð°ÑÑÐ¸ÑÑ ÑÐ¾, ÑÑÐ¾ ÑÐ°ÑÐ¿Ð¾Ð·Ð½Ð°Ð»Ð¾ÑÑ Ð² ÑÐ°Ð¹Ð»Ðµ, Ð±ÐµÐ·
  // ÑÐµÑÐµÐ²Ð¾Ð³Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð½Ð° ÐºÐ°Ð¶Ð´ÑÑ ÑÑÑÐ¾ÐºÑ
  useEffect(() => {
    Promise.all([getCities(), getMarks({ page: 1 })])
      .then(([citiesRes, marksRes]) => {
        setCities(citiesRes?.data || []);
        setMarks(marksRes?.data?.marks || []);
      })
      .finally(() => setReferenceLoaded(true));
  }, []);

  // ÐÐ¾ÑÑÐ´Ð¾Ðº Ð²ÐºÐ»Ð°Ð´Ð¾Ðº = Ð¿Ð¾ÑÑÐ´Ð¾Ðº ÑÐ°Ð±Ð¾ÑÑ: ÑÐ½Ð°ÑÐ°Ð»Ð° ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ (Ð¾Ñ Ð½Ð¸Ñ Ð·Ð°Ð²Ð¸ÑÑÑ ÑÐµÐ½Ð° Ð¿Ð¾
  // Ð¿ÑÐ¸ÐºÐ°Ð·Ñ Ð¸ Ð¾ÑÐ½Ð°ÑÐµÐ½Ð¸Ðµ, ÑÐ°ÑÑÑ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð·Ð°Ð¼ÐµÑÐ°Ð½Ð¸Ð¹ ÑÑÐ¾Ð´Ð¸Ñ ÑÐ°Ð¼Ð°), Ð¿Ð¾ÑÐ¾Ð¼ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ,
  // Ð¿Ð¾ÑÐ¾Ð¼ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐµ Ð¾ÑÐ¸Ð±ÐºÐ¸
  const complectationRows = useMemo(() => rows.filter((r) => r.complectationUnknown), [rows]);
  const errorRows = useMemo(() => rows.filter((r) => !r.originOnly && !r.complectationUnknown), [rows]);
  const originOnlyRows = useMemo(() => rows.filter((r) => r.originOnly && !r.complectationUnknown), [rows]);

  // ÐÐµÐ¹Ð´Ð¶ Ñ Ð¸Ð¼ÐµÐ½ÐµÐ¼ ÑÐ°Ð¹Ð»Ð° Ð¸Ð¼ÐµÐµÑ ÑÐ¼ÑÑÐ», ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð³Ð´Ð° ÑÑÑÐ¾ÐºÐ¸ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð¿ÑÐ¸ÑÐ»Ð¸ Ð¸Ð·
  // Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ñ ÑÐ°Ð¹Ð»Ð¾Ð² â Ð¿ÑÐ¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐµ Ð¾Ð´Ð½Ð¾Ð³Ð¾ ÑÐ°Ð¹Ð»Ð° ÑÑÐ¾ Ð¿ÑÐ¾ÑÑÐ¾ ÑÑÐ¼ Ð² Ð¸Ð½ÑÐµÑÑÐµÐ¹ÑÐµ
  const showFileNames = useMemo(() => new Set(rows.map((r) => r.fileName).filter(Boolean)).size > 1, [rows]);

  // ÐÐ¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð¾ÑÐºÑÑÐ²Ð°ÐµÐ¼ ÑÑ Ð²ÐºÐ»Ð°Ð´ÐºÑ, Ð³Ð´Ðµ ÑÐµÐ°Ð»ÑÐ½Ð¾ ÐµÑÑÑ ÑÑÑÐ¾ÐºÐ¸ â Ð¿ÑÐ¸ Ð¼Ð°ÑÑÐ¾Ð²Ð¾Ð¹
  // Ð²ÑÐ³ÑÑÐ·ÐºÐµ Ð¸Ð· CRM ÑÑÐ¾ Ð¿Ð¾ÑÑÐ¸ Ð²ÑÐµÐ³Ð´Ð° ÑÐ¾Ð»ÑÐºÐ¾ "Ð½ÐµÑ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ", Ð¸ Ð½ÐµÐ·Ð°ÑÐµÐ¼
  // Ð·Ð°ÑÑÐ°Ð²Ð»ÑÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð»Ð¸ÑÐ½Ð¸Ð¹ ÑÐ°Ð· ÑÑÐ»ÐºÐ°ÑÑ
  // Ð¸ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÐµÐ¼ÑÑ Ð´Ð°Ð»ÑÑÐµ, ÐºÐ¾Ð³Ð´Ð° ÑÐµÐºÑÑÐ°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ° Ð¾Ð¿ÑÑÑÐµÐ»Ð° (Ð²ÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸
  // ÑÐ°Ð·Ð¾Ð±ÑÐ°Ð½Ñ â Ð¸Ð´ÑÐ¼ Ðº Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ)
  useEffect(() => {
    const counts = {
      complectations: complectationRows.length,
      origin: originOnlyRows.length,
      errors: errorRows.length,
    };
    if (activeTab !== null && counts[activeTab] > 0) return;
    const next = ['complectations', 'origin', 'errors'].find((tab) => counts[tab] > 0);
    if (next) setActiveTab(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complectationRows.length, originOnlyRows.length, errorRows.length]);

  const applyOriginToAll = () => {
    if (!bulkOrigin) return;
    setOriginByRow(() => {
      const next = {};
      rows.forEach((r) => {
        next[rowKey(r)] = bulkOrigin;
      });
      return next;
    });
  };

  // Ð¡ÑÐ°Ð±Ð¸Ð»ÑÐ½ÑÐµ ÑÑÑÐ»ÐºÐ¸ Ð½Ð° ÐºÐ¾Ð»Ð±ÑÐºÐ¸ (useCallback) â Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ñ Ð´Ð»Ñ ÑÐ¾Ð³Ð¾, ÑÑÐ¾Ð±Ñ
  // React.memo Ñ PendingErrorRow ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°Ð» ÑÐµ-ÑÐµÐ½Ð´ÐµÑ ÑÑÑÐ¾Ðº, ÐºÐ¾ÑÐ¾ÑÑÑ
  // Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð½Ðµ ÐºÐ¾ÑÐ½ÑÐ»Ð¾ÑÑ (Ð¸Ð½Ð°ÑÐµ Ð¿ÑÐ¾Ð¿Ñ Ñ Ð½Ð¾Ð²Ð¾Ð¹ ÑÑÐ½ÐºÑÐ¸ÐµÐ¹ Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐµÐ½Ð´ÐµÑ
  // ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ ÑÐ²Ð¾Ð´Ð¸Ð» Ð±Ñ memo Ð½Ð° Ð½ÐµÑ)
  const handleModelCreated = useCallback((markId, modelOption) => {
    if (!markId || !modelOption) return;
    const key = `${markId}|${(modelOption.label || '').toLowerCase()}`;
    setCreatedModels((prev) => ({ ...prev, [key]: modelOption }));
  }, []);

  const toggleRowExpanded = useCallback((key) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  }, []);

  const handleOriginChange = useCallback((key, val) => {
    setOriginByRow((prev) => ({ ...prev, [key]: val }));
  }, []);

  // ÐÐ´Ð¸Ð½Ð°Ñ ÑÐ¾ÑÐºÐ° ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ â Ð±ÑÐº Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑ Ð°ÐºÑÑÐ°Ð»ÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÑÑÐ¾Ðº,
  // ÐµÑÑ Ð¾ÑÑÐ°Ð²ÑÐ¸ÑÑÑ Ð² ÑÐµÑÑÐ¸Ð¸ (Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð´Ð¸Ð½Ð¾ÑÐ½Ð¾Ð³Ð¾, Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¼Ð°ÑÑÐ¾Ð²Ð¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¼Ð¸ÑÐ°), ÑÐ°Ðº
  // ÑÑÐ¾ Ð¿ÑÐ¾ÑÑÐ¾ Ð·Ð°Ð¼ÐµÐ½ÑÐµÐ¼ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¸Ð¼, Ð²Ð¼ÐµÑÑÐ¾ ÑÑÑÐ½Ð¾Ð³Ð¾ Ð²ÑÑÑÑÐºÐ¸Ð²Ð°Ð½Ð¸Ñ Ð¿Ð¾ Ð¸Ð½Ð´ÐµÐºÑÑ
  const applyCommitResult = useCallback(
    (data) => {
      setRows(data.pendingRows || []);
      onResolved && onResolved(data);
    },
    [onResolved]
  );

  const handleRowSubmit = useCallback(
    async (resolution) => {
      try {
        const response = await commitStockCorrections(sessionId, [resolution]);
        const data = response.data;

        if (data.imported > 0) {
          alert.success(`Ð¡ÑÑÐ¾ÐºÐ° ${resolution.row} Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð°`);
        }
        if (data.errors?.length) {
          alert.error(data.errors[0].message);
        }

        applyCommitResult(data);
      } catch (err) {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ð¹');
      }
    },
    [sessionId, applyCommitResult]
  );

  const handleComplectationCommit = useCallback(
    async (resolutions) => {
      try {
        const response = await commitStockCorrections(sessionId, resolutions);
        const data = response.data;

        if (data.imported > 0) {
          alert.success(`ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾ ÑÑÑÐ¾Ðº: ${data.imported}`);
        }
        if (data.errors?.length) {
          alert.error(`ÐÑÐ¸Ð±Ð¾Ðº Ð¿ÑÐ¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐµ: ${data.errors.length} (ÑÐ¼. Ð¿ÐµÑÐ²ÑÑ: ${data.errors[0].message})`);
        }

        applyCommitResult(data);
      } catch (err) {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ð¹');
      }
    },
    [sessionId, applyCommitResult]
  );

  const handleOriginOnlySubmit = async (row) => {
    const originOption = originOf(row);
    if (!originOption) {
      alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ');
      return;
    }
    setSubmittingOriginRows((prev) => new Set(prev).add(rowKey(row)));
    try {
      const response = await commitStockCorrections(sessionId, [buildOriginOnlyResolution(row, originOption)]);
      const data = response.data;

      if (data.imported > 0) {
        alert.success(`Ð¡ÑÑÐ¾ÐºÐ° ${row.row} Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð°`);
      }
      if (data.errors?.length) {
        alert.error(data.errors[0].message);
      }

      applyCommitResult(data);
    } catch (err) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ð¹');
    } finally {
      setSubmittingOriginRows((prev) => {
        const next = new Set(prev);
        next.delete(rowKey(row));
        return next;
      });
    }
  };

  const handleImportAllOriginOnly = async () => {
    const ready = originOnlyRows.filter((r) => originOf(r));
    if (ready.length === 0) {
      alert.error('Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ¾ÑÑ Ð±Ñ Ð´Ð»Ñ Ð¾Ð´Ð½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¸');
      return;
    }
    setImportingOriginOnly(true);
    try {
      const resolutions = ready.map((r) => buildOriginOnlyResolution(r, originOf(r)));
      const response = await commitStockCorrections(sessionId, resolutions);
      const data = response.data;

      if (data.imported > 0) {
        alert.success(`ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾ ÑÑÑÐ¾Ðº: ${data.imported}`);
      }
      if (data.errors?.length) {
        alert.error(`ÐÑÐ¸Ð±Ð¾Ðº Ð¿ÑÐ¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐµ: ${data.errors.length} (ÑÐ¼. Ð¿ÐµÑÐ²ÑÑ: ${data.errors[0].message})`);
      }

      applyCommitResult(data);
    } catch (err) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ð¹');
    } finally {
      setImportingOriginOnly(false);
    }
  };

  if (rows.length === 0) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>Ð¡ÑÑÐ¾ÐºÐ¸, ÑÑÐµÐ±ÑÑÑÐ¸Ðµ ÑÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ({rows.length})</span>
        <div className={styles.bulkOrigin}>
          <Select
            title="ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð´Ð»Ñ Ð²ÑÐµÑ"
            placeholder="ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ð¾"
            options={originOptions}
            value={bulkOrigin}
            onChange={setBulkOrigin}
          />
          <Button text="ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ ÐºÐ¾ Ð²ÑÐµÐ¼" onClick={applyOriginToAll} disabled={!bulkOrigin} />
        </div>
      </div>

      <div className={styles.tabBar}>
        <button
          type="button"
          className={`${styles.tabButton} ${activeTab === 'complectations' ? styles.tabButtonActive : ''}`}
          onClick={() => setActiveTab('complectations')}
          disabled={complectationRows.length === 0}
        >
          ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ ({complectationRows.length})
        </button>
        <button
          type="button"
          className={`${styles.tabButton} ${activeTab === 'origin' ? styles.tabButtonActive : ''}`}
          onClick={() => setActiveTab('origin')}
          disabled={originOnlyRows.length === 0}
        >
          ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ({originOnlyRows.length})
        </button>
        <button
          type="button"
          className={`${styles.tabButton} ${activeTab === 'errors' ? styles.tabButtonActive : ''}`}
          onClick={() => setActiveTab('errors')}
          disabled={errorRows.length === 0}
        >
          ÐÑÐ¸Ð±ÐºÐ¸ ({errorRows.length})
        </button>
      </div>

      {!referenceLoaded ? (
        <div className={styles.row}>ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¾Ð²â¦</div>
      ) : (
        <>
          {activeTab === 'complectations' && complectationRows.length > 0 && (
            <ComplectationQuestions rows={complectationRows} onCommit={handleComplectationCommit} />
          )}

          {activeTab === 'origin' && originOnlyRows.length > 0 && (
            <div className={styles.originOnlySection}>
              <div className={styles.originOnlyHeader}>
                <div className={styles.sectionHint}>
                  ÐÑÑÐ°Ð»ÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ ÑÐ¶Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ñ â ÑÐºÐ°Ð¶Ð¸ÑÐµ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÑÐ¹ÑÐµ
                </div>
                <Button
                  fill
                  text={
                    importingOriginOnly
                      ? 'ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÑÐµÑÑÑâ¦'
                      : `ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð²ÑÐµ (${originOnlyRows.filter((r) => originOf(r)).length})`
                  }
                  onClick={handleImportAllOriginOnly}
                  disabled={importingOriginOnly || originOnlyRows.every((r) => !originOf(r))}
                />
              </div>
              <table className={styles.originTable}>
                <thead>
                  <tr>
                    {showFileNames && <th>Ð¤Ð°Ð¹Ð»</th>}
                    <th>VIN</th>
                    <th>ÐÐ°ÑÐºÐ° / Ð¼Ð¾Ð´ÐµÐ»Ñ</th>
                    <th>ÐÐ¾ÑÐ¾Ð´</th>
                    <th>ÐÐ¦</th>
                    <th>ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {originOnlyRows.map((row) => (
                    <tr key={rowKey(row)}>
                      {showFileNames && <td className={styles.fileCell}>{row.fileName}</td>}
                      <td>{row.vin}</td>
                      <td>
                        {row.markName} {row.modelName}
                      </td>
                      <td>{row.cityName}</td>
                      <td>{row.dcName}</td>
                      <td className={styles.originTableSelectCell}>
                        <Select
                          placeholder="ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ð¾"
                          options={originOptions}
                          value={originOf(row)}
                          disabled={submittingOriginRows.has(rowKey(row))}
                          onChange={(val) => handleOriginChange(rowKey(row), val)}
                        />
                      </td>
                      <td>
                        <Button
                          fill
                          text={submittingOriginRows.has(rowKey(row)) ? 'ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÑÐµÑÑÑâ¦' : 'ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ'}
                          onClick={() => handleOriginOnlySubmit(row)}
                          disabled={submittingOriginRows.has(rowKey(row))}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Ð¢Ð¾Ð¶Ðµ Ð²ÑÐµÐ³Ð´Ð° ÑÐ¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¾, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð³Ð´Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐ° Ð°ÐºÑÐ¸Ð²Ð½Ð° â Ð¸Ð½Ð°ÑÐµ
              Ð¿ÐµÑÐµÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ð½Ð° "ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ" Ð¸ Ð¾Ð±ÑÐ°ÑÐ½Ð¾ ÑÐ¾ÑÐ½Ð¾ ÑÐ°Ðº Ð¶Ðµ
              ÑÐ±ÑÐ°ÑÑÐ²Ð°Ð»Ð¾ Ð±Ñ ÑÐ¾ÑÐ¼Ñ, ÐºÐ°Ðº Ð¸ ÑÐ²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ðµ/ÑÐ°Ð·Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ðµ ÑÑÑÐ¾ÐºÐ¸ */}
          <div style={{ display: activeTab === 'errors' ? undefined : 'none' }}>
            {errorRows.map((row) => (
              <PendingErrorRow
                key={rowKey(row)}
                row={row}
                isExpanded={expandedRows.has(rowKey(row))}
                showFileNames={showFileNames}
                originOptions={originOptions}
                originOption={originByRow[rowKey(row)] || null}
                allCities={cities}
                allMarks={marks}
                onToggle={toggleRowExpanded}
                onOriginChange={handleOriginChange}
                onSubmitRow={handleRowSubmit}
                dcCache={dcCacheRef.current}
                createdModels={createdModels}
                onModelCreated={handleModelCreated}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default StockPendingRowsTable;
